import { ConfigurationSourceDataMap } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import ConfigurationSourceDataFormForm from "@/components/forms/forms/source-data-configuration/ConfigurationSourceDataFormForm";
import ConfigurationSourceDataFormVersionForm from "@/components/forms/forms/source-data-configuration/ConfigurationSourceDataFormVersionForm";
import MetadataContext from "@/contexts/data/MetadataContext";
import TrialContext from "@/contexts/data/TrialContext";
import ConfigurationSourceDataFormContext from "@/contexts/form/ConfigurationSourceDataFormContext";
import useFormVersionConfiguration from "@/hooks/form/configuration/useFormVersionConfiguration";
import useDebouncedValue from "@/hooks/utility/useDebouncedValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle } from "@mui/material";
import { useScopedField } from "@ngt/forms-core";
import { FC, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";

const ConfigurationSourceDataFormVersion: FC = () => {
    const { studyEventOid, caseReportFormOid, caseReportFormVersionOid } = useParams();

    const { data: trial } = useContext(TrialContext);
    const { data: metadata } = useContext(MetadataContext);
    const { state: { value: configuration } } = useScopedField<ConfigurationSourceDataMap>('configuration', { value: true });
    const { state: { value: trialConfiguration } } = useScopedField<ConfigurationSourceDataMap>('trialConfiguration', { value: true });


    const {
        state: debouncedConfiguration,
        doNotDebounceNextUpdate: doNoteDebounceNextConfigurationUpdate
    } = useDebouncedValue(configuration, 500);

    const {
        state: debouncedTrialConfiguration,
        doNotDebounceNextUpdate: doNoteDebounceNextTrialConfigurationUpdate
    } = useDebouncedValue(trialConfiguration, 500);

    const onLinkUpdate = useCallback(() => {
        doNoteDebounceNextConfigurationUpdate();
        doNoteDebounceNextTrialConfigurationUpdate();
    }, [doNoteDebounceNextConfigurationUpdate, doNoteDebounceNextTrialConfigurationUpdate]) 

    const { baseRoute } = useContext(ConfigurationSourceDataFormContext);
    
    const formVersionData = useFormVersionConfiguration(
        metadata,
        debouncedTrialConfiguration ?? undefined,
        debouncedConfiguration ?? undefined,
        trial,
        debouncedConfiguration?.configuration?.id,
        studyEventOid,
        caseReportFormOid,
        caseReportFormVersionOid,
        baseRoute
    );

    if (!formVersionData) {
        return (
            <Alert
                icon={<FontAwesomeIcon icon={AppSettings.icons.alertWarning} />}
                severity="warning"
            >
                <AlertTitle>Form Version Not Found</AlertTitle>
                The {studyEventOid} {caseReportFormOid} {caseReportFormVersionOid} form version was not found.
            </Alert> 
        )
    }
    
    return (
        <>
            <ConfigurationSourceDataFormVersionForm
                data={formVersionData}
                onLinkUpdate={onLinkUpdate}
            />
        </>
    )
};

export default ConfigurationSourceDataFormVersion;